import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";
import DynamicObjectOverview from "@/pages/dynamic/list-views/DynamicObjectOverview";

function RequestForQuotationOverview() {
  return (
    <DynamicObjectOverview
      objectName={dynamicObjectMap.get("RequestForQuotationObjectName")}
      showFilters
      showActionButton={false}
      noDataHideButton
    />
  );
}

export default RequestForQuotationOverview;
